import React, { useMemo } from 'react';
import { Box } from '@material-ui/core';
import Swiper from 'react-id-swiper';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

import { BREAKPOINTS_VALUES } from '../../theme';
import { ExpertCard } from '../ExpertCard';
import { User } from '../../types';
import useStyles from './styles';
import { ExpertCardType } from '../ExpertCard/ExpertCard';
import { splitIntoChunks } from '../../utils/helpers';

const swiperSettings = {
  slidesPerView: 1,
  spaceBetween: 16,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  mousewheel: {
    releaseOnEdges: true,
    forceToAxis: true,
    invert: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  direction: 'horizontal',
  rebuildOnUpdate: true,
  breakpoints: {
    [BREAKPOINTS_VALUES.xl]: {
      slidesPerView: 6,
    },
    1000: {
      slidesPerView: 5,
    },
    [BREAKPOINTS_VALUES.md]: {
      slidesPerView: 4,
    },
  },
};

const CHUNK_MOBILE_LENGTH = 4;
const CHUNK_TABLET_LENGTH = 6;

interface ExpertsSliderProps {
  experts?: User[];
  width: Breakpoint;
  withLinks?: boolean;
  tileType?: ExpertCardType;
}

export const ExpertsSlider: React.FC<ExpertsSliderProps> = ({
  experts,
  width,
  withLinks = false,
  tileType = 'light',
}) => {
  const classes = useStyles();
  const isMobile = !isWidthUp('sm', width);
  const isTablet = !isWidthUp('md', width);

  const chunkLength = useMemo(() => {
    return isMobile ? CHUNK_MOBILE_LENGTH : CHUNK_TABLET_LENGTH;
  }, [isMobile]);

  const chunks = useMemo(() => {
    return isTablet ? splitIntoChunks(experts, chunkLength) : experts;
  }, [isTablet, chunkLength, experts]);

  return (
    <div className={classes.swiperWrapper}>
      <Swiper {...swiperSettings}>
        {chunks &&
          chunks.map((chunk) =>
            isTablet ? (
              <Box key={chunk?.[0]?.id} className={classes.chunkWrapper}>
                {chunk &&
                  chunk.map((expert) => (
                    <div key={`c-${expert?.id}`} className={classes.chunk}>
                      <ExpertCard
                        title={expert?.name}
                        imageUrl={expert?.avatar}
                        jobTitle={expert?.job_title}
                        slug={expert?.slug}
                        wrapperClass={classes.expertItem}
                        withLink={withLinks}
                        type={tileType}
                      />
                    </div>
                  ))}
              </Box>
            ) : (
              <Box key={chunk?.id}>
                <ExpertCard
                  title={chunk?.name}
                  imageUrl={chunk?.avatar}
                  jobTitle={chunk?.job_title}
                  slug={chunk?.slug}
                  withLink={withLinks}
                  type={tileType}
                />
              </Box>
            ),
          )}
      </Swiper>
    </div>
  );
};

export default withWidth()(ExpertsSlider);
